import { render, staticRenderFns } from "./tableOthersDelegatedTasks.vue?vue&type=template&id=bef408c2&scoped=true"
import script from "./tableOthersDelegatedTasks.vue?vue&type=script&lang=js"
export * from "./tableOthersDelegatedTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef408c2",
  null
  
)

export default component.exports